function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as R } from "react/jsx-runtime";
import * as a from "react";
import { useRifm as x } from "rifm";
import { getRegionCodeForCountryCode as N, formatToE164 as T, parse as k, formatAsYouType as A } from "@telefonica/libphonenumber";
import { useFieldProps as B } from "./form-context.js";
import { TextFieldBaseAutosuggest as E } from "./text-field-base.js";
import { useTheme as V } from "./hooks.js";
import { createChangeEvent as S } from "./utils/dom.js";
import { combineRefs as Z } from "./utils/common.js";
const P = (r, s)=>A(s.replace(/[^\d+*#]/g, ""), r), $ = (r)=>!!r.match(/^\+\d+$/), j = (_param)=>{
    var { inputRef: r , value: s , defaultValue: m , onChange: i , prefix: t , e164: b  } = _param, p = _object_without_properties(_param, [
        "inputRef",
        "value",
        "defaultValue",
        "onChange",
        "prefix",
        "e164"
    ]);
    const [f, d] = a.useState(m !== null && m !== void 0 ? m : ""), l = a.useRef(null), { i18n: g  } = V(), c = g.phoneNumberFormattingRegionCode, n = typeof s < "u", h = n ? s : f, y = a.useCallback((o)=>{
        n || d(o), l.current && (i == null || i(S(l.current, o)));
    }, [
        n,
        i
    ]), C = a.useCallback(// The final replacement of "-" to "@" is to workaround a bug in rifm library
    // otherwise the cursor position is incorrectly positioned
    // also note the "@" is replaced back to "-" in `replace` param in `useRifm`
    (o)=>{
        let e = "";
        if (t && $(t)) {
            const F = t + o;
            e = P(c, F), e.startsWith(t) ? e = e.slice(t.length).trim() : e = P(c, o);
        } else e = P(c, o);
        return e.replace(/-/g, "@");
    }, [
        c,
        t
    ]), u = x({
        format: C,
        value: h,
        onChange: y,
        accept: /[\d\-()+#*]+/g,
        replace: (o)=>o.replace(/@/g, "-")
    });
    return /* @__PURE__ */ R("input", _object_spread_props(_object_spread({}, p), {
        value: u.value,
        onChange: u.onChange,
        type: "tel",
        ref: Z(r, l)
    }));
}, I = (_param)=>{
    var { disabled: r , error: s , helperText: m , name: i , optional: t , validate: b , onChange: p , onChangeValue: f , onBlur: d , value: l , defaultValue: g , e164: c  } = _param, n = _object_without_properties(_param, [
        "disabled",
        "error",
        "helperText",
        "name",
        "optional",
        "validate",
        "onChange",
        "onChangeValue",
        "onBlur",
        "value",
        "defaultValue",
        "e164"
    ]);
    const { i18n: h  } = V(), C = B({
        name: i,
        value: l,
        defaultValue: g,
        processValue: (u)=>{
            if (c) try {
                var _n_prefix;
                const o = ((_n_prefix = n.prefix) !== null && _n_prefix !== void 0 ? _n_prefix : "").replace(/[^\d]/g, "");
                let e = N(o);
                return (!e || e === "ZZ") && (e = h.phoneNumberFormattingRegionCode), T(k(u, e));
            } catch (e) {
                return "";
            }
            else return u.replace(/[^\d]/g, "");
        },
        helperText: m,
        optional: t,
        error: s,
        disabled: r,
        onBlur: d,
        validate: b,
        onChange: p,
        onChangeValue: f
    });
    return /* @__PURE__ */ R(E, _object_spread_props(_object_spread({}, n, C), {
        type: "phone",
        inputProps: {
            prefix: n.prefix
        },
        inputComponent: j
    }));
}, J = I;
export { J as default };
